import LayoutBackend from '@/layouts/variations/Backend.vue';
import { requireAuthWithPrefetchedUserInfo } from '@/router/helpers.js';

const Home = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Home.vue');
const MyCoupon = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Coupon/MyCoupon.vue');
const MySubscription = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Subscription/Subscription.vue');
const MyLotto = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Lotto/Lotto.vue');
const MyTransaction = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Transaction/Transaction.vue');
const MyInfo = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Info/Information.vue');

const InviteFriends = () => /* webpackChunkName: "group-mypage" */ import('@/views/My/Invite/Invite.vue');
const MyNotifications = () =>
  /* webpackChunkName: "group-mypage" */ import('@/views/My/Notifications/Notifications.vue');

const mypage = [
  {
    path: '/my',
    name: 'MyPage',
    redirect: '/my/home',
    component: LayoutBackend,
    beforeEnter: requireAuthWithPrefetchedUserInfo(),
    children: [
      {
        path: 'home',
        name: 'MyHome',
        component: Home,
      },
      {
        path: 'coupon',
        name: 'MyCoupon',
        component: MyCoupon,
      },
      {
        path: 'subscription',
        name: 'MySubscription',
        component: MySubscription,
      },
      {
        path: 'lotto',
        name: 'MyLotto',
        component: MyLotto,
      },
      {
        path: 'transaction',
        name: 'MyTransaction',
        component: MyTransaction,
      },
      {
        path: 'info',
        name: 'MyInfo',
        component: MyInfo,
      },
      {
        path: 'invite',
        name: 'InviteFriends',
        component: InviteFriends,
      },
      {
        path: 'notifications',
        name: 'Alert',
        component: MyNotifications,
      },
    ],
  },
];

export { mypage };
